module.exports = __webpack_public_path__ + "static/media/as949390010024.8f1006b4.jpg";